import jQuery from 'jquery';
import $ from 'jquery';

window.appius = window.appius || {};

window.appius.scroller = (function ($) {
    "use strict";
    var module = {};
    var speed = 1500;

    module.scrollToElem = function ($elem, offset) {
        if (!$elem) { return false; }

        try {
            var elemPos = $elem.offset().top;



            if ($elem.is(":hidden")) return false;

            module.scrollToPosition(elemPos, null, offset);
        }
        catch { }
    };

    module.scrollToPosition = function (pos, hash, offset) {
        if (typeof offset === "undefined") { offset = 0; }

        $('html, body').animate({
            scrollTop: (pos + offset)
        }, speed, function () {
            // This causes an issue with the scrolling due to the sticky banner not being accommodated for when we set the hash.
            // if (typeof hash !== undefined && hash !== null) {
            //     window.location.hash = hash;
            // }
        });
    };

    module.goToElement = function ($elem, offset) {
        try {
            if (!$elem) { return false; }
            if (typeof offset === "undefined") { offset = 0; }

            var elemPos = $elem.offset().top;

            if ($elem.is(":hidden")) return false;

            $('html, body').scrollTop((elemPos + offset + 1))
        } catch {

        }
    };

    function identfyScrollPosition(event, urlHash) {

        var $a = event ? $(event.target) : null,
            href = $a ? $a.attr('href') : null,
            hash,
            $target,
            offset = 0;

        if (href || urlHash) {
            hash = href ? href.substring(href.indexOf('#')) : urlHash
            $target = hash == "#" ? null : $(hash)
        }

        // Sticky header override
        const $stickyHeader = $('.header__sticky');
        if ($stickyHeader.length > 0) {
            const stickyHeaderHeight = $stickyHeader.height();
            offset -= stickyHeaderHeight;
        }

        if (event) event.preventDefault();

        setTimeout(function () {

            if ($target && $target.length) {
                if (event) event.preventDefault();
                offset += $target.offset().top;
                offset -= 10; // Slight amount of padding to add breathing space

                module.scrollToPosition(offset, hash);
            }
        }, 500)
    }

    module.init = function () {
        var $scroll = $('html, body'),
            $body = $scroll.filter('body');

        $body.on('click', 'a[href*="#"]:not([data-toggle="collapse"])', function (event) {
            identfyScrollPosition(event);
        });
    };

    $(document).ready(function () {
        module.init();

        var hash = window.location.hash;
        if (hash) {
            window.scrollTo(0, 0);
            identfyScrollPosition(event, hash);
        }
    });

    $(document).ready(function () {
        $('a[href^="#"]').on('click', function (event) {
            var target = $(this.getAttribute('href'));
            if (target.length) {
                event.preventDefault();
                $('html, body').stop().animate({
                    scrollTop: target.offset().top
                }, 1000);
            }
        });
    });

        return module;

})(jQuery);
